(() => {
  'use strict';
  const controllers = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-cinematic-hero]').forEach(hero => {
      if (controllers.has(hero)) return;
      const video = hero.querySelector('[data-hero-video]');
      const toggle = hero.querySelector('[data-hero-toggle]');
      if (!video || !toggle) return;
      const events = new AbortController();
      const options = {signal: events.signal};
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, userPaused = false, manualPlay = false, frame = 0, failed = false;
      toggle.hidden = false;
      function sync() {
        const playing = !video.paused;
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.setAttribute('aria-label', playing ? 'Hintergrundvideo pausieren' : 'Hintergrundvideo abspielen');
      }
      function play() {
        if (failed) return;
        if (!video.getAttribute('src')) {
          const size = matchMedia('(min-width: 800px)').matches ? 'desktop' : 'mobile';
          video.src = video.dataset[size + 'Src'];
        }
        video.muted = true;
        video.play().catch(sync);
      }
      function reconcile() {
        if (visible && !document.hidden && !userPaused && (!reduced.matches || manualPlay)) play();
        else video.pause();
      }
      toggle.addEventListener('click', () => {
        if (video.paused) { userPaused = false; manualPlay = true; play(); }
        else { userPaused = true; video.pause(); }
      }, options);
      video.addEventListener('playing', () => {hero.classList.add('is-video-ready');sync();}, options);
      video.addEventListener('pause', sync, options);
      video.addEventListener('error', () => {
        // Keep the first-frame poster and shopping links usable if media cannot load.
        failed = true;
        hero.classList.remove('is-video-ready');
        toggle.hidden = true;
      }, options);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .12;
        reconcile();
      }, {threshold: [0, .12]});
      observer.observe(hero);
      document.addEventListener('visibilitychange', reconcile, options);
      reduced.addEventListener('change', () => {manualPlay = false;reconcile();requestUpdate();}, options);
      function update() {
        frame = 0;
        const bounds = hero.getBoundingClientRect();
        const progress = reduced.matches ? 0 : Math.max(0, Math.min(1, -bounds.top / bounds.height));
        hero.style.setProperty('--hero-progress', progress.toFixed(3));
      }
      function requestUpdate() {if (!frame) frame = requestAnimationFrame(update);}
      window.addEventListener('scroll', requestUpdate, {...options, passive: true});
      window.addEventListener('resize', requestUpdate, options);
      update();sync();
      controllers.set(hero, () => {video.pause();observer.disconnect();events.abort();cancelAnimationFrame(frame);});
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, hero) => {if (event.target.contains(hero)) {dispose();controllers.delete(hero);}});
  });
})();
